export const elemClassName = (blockName: string, elemName: string) => `${blockName}__${elemName}`;
